/** @file Runs the compiled update order: applied to world per bone, IK solves interleaved. */
import type { Pose } from '../contracts/pose';
import type { SkeletonData } from '../skeletonData';
import { updateOps } from './updateOps';

/**
 * Computes world transforms from applied along data.updateOrder, invoking IK handlers in order. applied is first
 * reset to a copy of local, so constraints never accumulate across calls; flipX is placement (adapters), not here.
 */
export function updatePose(pose: Pose, data: SkeletonData): void {
  pose.applied.set(pose.local);
  const order = data.updateOrder;
  for (let i = 0; i < order.length; i++) {
    const op = order[i];
    if (op !== undefined) updateOps[op[0]](pose, data, op[1]);
  }
}
